<template>
    <v-app id="app_measurements">
        <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
            <v-progress-circular color="#2A8200" indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-container fluid>
            <v-row>
                <v-col class="mt-0" cols="7">
                    <p class="custom_page_main_title"> OVERTIME REQUEST APPROVED LIST </p>
                    <p class="custom_page_main_sub_title" style="opacity: 0.6">
                        Used to manage overtime approved requests.
                    </p>
                </v-col>
                <v-col class="px-4 mt-7" cols="5">
                    <v-row class="custom_tool_bar_style">
                        <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
                        <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute">
                            <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>

            <v-card class="pa-5 mt-5">
                <v-row justify="end">
                    <v-col cols="auto">
                        <v-btn class="custom_excel_btn" variant="outlined" @click="exportExcel">
                            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
                        </v-btn>
                    </v-col>
                    <v-divider></v-divider>
                </v-row>

                <v-row>

                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="userCatagory" :items="userCatagaryItems" clearable item-title="name"
                            item-value="name" label="Officer Category" multiple placeholder="Select Officer Category"
                            variant="outlined" density="comfortable" class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="userCatagory" :items="userCatagaryItems" clearable item-title="name"
                            item-value="name" label="Officer" multiple placeholder="Select Oficer Name"
                            variant="outlined" density="comfortable" class="custom_input_field_color"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-date-input v-model="dates" label="Select Date Range" prepend-icon=""
                            prepend-inner-icon="$calendar" multiple="range" variant="outlined" clearable
                            @click:clear="clearDateRange()" density="comfortable"
                            class="custom_input_field_color"></v-date-input>
                    </v-col>
                </v-row>

                <v-row class="pa-2" style="background-color: #fff3cd; border: 1px solid #566573; border-radius: 4px;">
                    <v-col class="d-flex align-center" cols="12">
                        <v-icon color="success" size="small" class="mr-1">mdi-checkbox-blank-circle</v-icon>
                        <span class="mr-4" style="font-size: 12px; color: #333;">ON TIME</span>

                        <v-icon color="error" size="small" class="mr-1">mdi-checkbox-blank-circle</v-icon>
                        <span style="font-size: 12px; color: #333;">LATE</span>
                    </v-col>
                </v-row>

                <v-data-table class="mt-4" :group-by="groupBy" :headers="headers" :items="desserts"
                    item-value="officerName">
                    <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen }">
                        <tr>
                            <td :colspan="columns.length">
                                <v-btn :icon="isGroupOpen(item) ? '$expand' : '$next'" size="small" variant="text"
                                    @click="toggleGroup(item)" />
                                <div>
                                    <span class="text-muted">
                                        {{ item.value ? 'Mr. Tharindu Chandrasiri' : 'Mr. Ransilu Obeysekera' }}
                                    </span>
                                    <br />
                                    <span class="blue--text font-weight-bold">Reg num: {{ item.value ? '3566' : '9024'
                                        }}</span>
                                </div>
                            </td>
                        </tr>
                    </template>

                    <!-- <template v-slot:[`item.dayIn`]="{ item }">
                        <div class="d-flex align-center">
                            <v-icon v-if="isOnTime(item.dayIn)" color="success" size="small" class="mr-1">
                                mdi-checkbox-blank-circle
                            </v-icon>
                            <span v-if="isOnTime(item.dayIn)" class="mr-4" style="font-size: 12px; color: #333;">
                            </span>
                            <span>{{ item.dayIn }}</span>
                        </div>
                    </template> -->

                    <template v-slot:[`item.requestedHours`]="{ item }">
                        <div class="text-left">
                            <span class="blue--text "><strong class="black--text font-weight-bold">From:</strong> {{
                                item.requestedHours.from }}</span><br />
                            <span class="blue--text "><strong class="black--text font-weight-bold">To:</strong> {{ item.requestedHours.to
                            }}</span><br />
                            <span class="red--text "><strong class="black--text font-weight-bold">Hours:</strong> {{
                                item.requestedHours.hours }}</span>
                        </div>
                    </template>

                    <template v-slot:[`item.dayIn`]="{ item }">
                        <div class="d-flex align-center">
                            <!-- Display icon if dayIn is valid -->
                            <v-icon v-if="item.dayIn.time" color="success" size="small" class="mr-1">
                                mdi-checkbox-blank-circle
                            </v-icon>
                            <div>
                                <span>{{ item.dayIn.time }}</span> <br />
                                <span class="blue--text font-weight-bold">{{ item.dayIn.address }}</span>
                                <!-- Address in blue -->
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.dayOut`]="{ item }">
                        <div>
                            <span>{{ item.dayOut.time }}</span> <br />
                            <span class="blue--text font-weight-bold">{{ item.dayOut.address }}</span>
                            <!-- Address in blue -->
                        </div>
                    </template>

                    <template v-slot:[`item.action`]="{ }">
                        <v-btn style="width: 90% !important; background-color: #fdecea !important;
                                    border: 1px solid #f44336 !important; color: #f44336 !important;"
                            variant="outlined" @click="rejectApproveddialog = true">
                            REJECT
                        </v-btn>
                    </template>
                </v-data-table>


                <v-dialog v-model="rejectApproveddialog" max-height="700" id="app_lead_list" max-width="600">
                    <v-card rounded="md">
                        <div class="pa-4">
                            <v-card color="#F0F0F0" flat>
                                <template v-slot:prepend>
                                    <v-card-title class="text-subtitle-1 font-weight-bold"> REJECT REQUEST
                                    </v-card-title>
                                </template>
                                <v-spacer></v-spacer>
                                <template v-slot:append>
                                    <v-btn @click="rejectApproveddialog = false" icon="mdi-close"
                                        size="x-small"></v-btn>
                                </template>
                            </v-card>

                            <!-- Form Content -->
                            <v-card-text>
                                <v-form ref="form">
                                    <v-textarea autocomplete="Message" label="Message"></v-textarea>
                                </v-form>
                            </v-card-text>

                            <!-- Action Buttons -->
                            <v-card-actions class="d-flex justify-end">
                                <v-btn style="width: 30% !important; background-color: #fdecea !important;
                                    border: 1px solid #f44336 !important; color: #f44336 !important;"
                                    variant="outlined" @click="InRequestdialog = true">
                                    REJECT
                                </v-btn>

                            </v-card-actions>
                        </div>
                    </v-card>
                </v-dialog>

            </v-card>




        </v-container>
    </v-app>
</template>

<script>
export default {
    data() {
        return {

            officeName: '',
            Datename: '',
            MessageName: '',


            rejectApproveddialog: false,
            centerLoading: false,
            userCategory: [],
            officerNames: [],
            dates: [],
            userCategoryItems: [{ name: "Category A" }, { name: "Category B" }],
            groupBy: [{ key: "officerName", order: "asc" }],
            headers: [
                { title: "OFFICER NAME", align: "start", sortable: false, key: "officerName" },
                { title: "DAY IN", key: "dayIn" },
                { title: "DAY OUT", key: "dayOut" },
                { title: "ALL WORKING HOURS", key: "AllWorkingHours" },
                { title: "REQUESTED OT HOURS", key: "requestedHours" },  // This will now display From, To, and Hours
                { title: "TOTAL OT HOURS", key: "TotalHours" },
                { title: "DATE", key: "date" },
                { title: "ACTION", key: "action" },
            ],
            desserts: [
                {
                    officerName: "Mr. Tharindu Chandrasiri",
                    dayIn: { time: "8:23 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "5:32 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    AllWorkingHours: "9 hours 56 minutes",
                    requestedHours: { from: "6:00 PM", to: "8:00 PM", hours: "02 Hours" },
                    TotalHours: "03 hours",
                    date: "2025-01-01",
                    action: "",
                },
                {
                    officerName: "Mr. Ransilu Obeysekera",
                    dayIn: { time: "8:24 AM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    dayOut: { time: "4:55 PM", address: "No.22/1, Kumaranakanda Road, Gonapuluwa" },
                    AllWorkingHours: "8 hours 56 minutes",
                    requestedHours: { from: "6:30 PM", to: "10:30 PM", hours: "04 Hours" },
                    TotalHours: "09 hours",
                    date: "2025-01-08",
                    action: "",
                },
            ]
        };
    },
    methods: {
        // clearDateRange() {
        //     this.dates = [];
        // },
        // backPageRoute() {
        //     console.log("Back button clicked");
        // },
        // exportExcel() {
        //     console.log("Export Excel clicked");
        // },

        isOnTime(time) {
            // Define a threshold for "ON TIME" (Example: Before 8:30 AM)
            const onTimeLimit = "8:30 AM";
            return time <= onTimeLimit; // Returns true if the time is ON TIME
        },

        actionItem(item) {
            console.log("Edit clicked for:", item);

        },
    },
};
</script>

<style scoped>
.blue--text {
    color: blue;
}

.red--text {
    color: red;
}

.black--text {
    color: black;
}
</style>
